import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Unit, UnitCreateParams, UnitUpdateParams } from '../models/unit.model';
import { UnitGateway } from '../usecases/unit.gateway';

@Injectable()
export class UnitService extends UnitGateway {
  constructor(private _http: HttpClient) {
    super();
  }

  createUnit(projectId: string, params: UnitCreateParams): Observable<Unit> {
    return this._http.post<Unit>(`api/vgs/projects/${projectId}/units`, params);
  }

  updateUnit(projectId: string, unitId: string, params: UnitUpdateParams): Observable<Unit> {
    return this._http.put<Unit>(`api/vgs/projects/${projectId}/units/${unitId}`, params);
  }

  updateUnitAssign(projectId: string, unitId: string): Observable<Unit> {
    return this._http.put<Unit>(`api/vgs/projects/${projectId}/units/${unitId}/working`, null);
  }

  deleteUnit(projectId: string, unitId: string): Observable<void> {
    return this._http.delete<void>(`api/vgs/projects/${projectId}/units/${unitId}`);
  }
}
